export interface ISolicitudesIngresoPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: SolicitudesIngreso[];
}
export interface SolicitudesIngreso {
  id_solicitudingreso?: string;
  codigo?: string;
  numero_referencia?: string;
  user?: string;
  motivo_rechazo?: string;
  //productos?: string;
  productos?: solicitud_ingreso[];
  estado_solicitud?: string;
  //observaciones?: string;
  observaciones?: Observaciones;
  estado?: string;
  fecha_creacion?: string;
  bodega?: string;
  ubicacion?: string;
  motivo?: string;
  unidad_transporte?: string;
  ubicacion_data?: {
    id?: string,
    codigo?: string;
    nombre?: string;

  }
  bodega_data?: {
    nombre?: string
    email?: string
  }
  urls_imagenes?:{
    archivoSolicitud?:string;
    archivoRevision?: string;

  }
}
export type Observaciones={
  observacionSolicitante?: string;
  observacionRevision?: string;
  observaciones?:string;
}
export interface solicitud_ingreso {
  id_solicitudingreso?: string;
  id?: string;
  codigo?: string;
  cantidad?: number | string;
  cantidad_recibida?: number | string;
  cantidad_aprobada?:number;
  descripcion?: string;
  stock_actual?: string;
  marca_producto?: string;
  modelo_producto?: string;
  categoria_producto?: string;
  subcategoria_producto?: string;
  unidad_medida?: string;
  stock?: number
  //series?: string [];
  id_producto?:string
  producto_data?: productoData;
  //
  cantidad_pendiente?:number;
  precio_compra?:number | string
  contiene_serie?: boolean

}
export type productoData={
  codigo: string;
  descripcion: string;
  categoria_producto: string;
  presentacion?:string;
  subcategoria_producto?: string;
  stock_actual?: number;
  modelo_producto?: string;
  marca_producto?:string;
  unidad_medida?: string;
} | null;

export type SaveSolicitudIngresoFormData = {
  user?: string;
  codigo?: string;
  productos?: string;
  estado_solicitud?: string;
  //observaciones?: string | 'N/A';
  observaciones:{
    observacionSolicitante:string;
  }
  fecha_creacion?: string;
  bodega: string;
  ubicacion: string;
  unidad_transporte?: string;
  cantidad_recibida?: number;
  email_remitente: string;
  email_receptor: string;
};

export type IngresoSolictud ={
  id_solicitudingreso?: string;
  codigo?: string;
  numero_referencia?: string;
  user?: string;
  motivo_rechazo?: string;
  //productos?: string;
  productos?: solicitud_ingreso[];
  estado_solicitud?: string;
  //observaciones?: string;
  observaciones?: string;
  estado?: string;
  fecha_creacion?: string;
  bodega?: string;
  ubicacion?: string;
  motivo?: string;
  unidad_transporte?: string;
}

export enum EstadosSolicitudIngresoEnum {
  ESPERA = 'EN ESPERA',
  APROBADAS = 'APROBADO',
  ABIERTO = "ABIERTO",
  RECHAZADO = 'RECHAZADO',
  FINALIZADO = 'FINALIZADO'
}